/**
 * LMG Wishlist — localStorage based, sin apps externas.
 * Global API: window.LMGWishlist
 *   .add(handle)
 *   .remove(handle)
 *   .toggle(handle) -> true if added, false if removed
 *   .has(handle) -> boolean
 *   .all() -> array of handles
 *   .count() -> number
 *   .subscribe(fn) -> unsubscribe fn (notify on change)
 */
(function () {
  var KEY = 'lmg-wishlist-v1';
  var listeners = [];

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    listeners.forEach(function (fn) { try { fn(arr); } catch (e) {} });
  }

  var api = {
    all: function () { return read(); },
    count: function () { return read().length; },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    add: function (handle) {
      var arr = read();
      if (arr.indexOf(handle) === -1) { arr.push(handle); write(arr); }
    },
    remove: function (handle) {
      var arr = read().filter(function (h) { return h !== handle; });
      write(arr);
    },
    toggle: function (handle) {
      var arr = read();
      var idx = arr.indexOf(handle);
      if (idx === -1) { arr.push(handle); write(arr); return true; }
      arr.splice(idx, 1); write(arr); return false;
    },
    subscribe: function (fn) {
      listeners.push(fn);
      return function () { listeners = listeners.filter(function (f) { return f !== fn; }); };
    }
  };

  window.LMGWishlist = api;

  // Auto-sync hearts: cualquier .lmg-heart[data-handle] se actualiza
  function syncHearts() {
    var hearts = document.querySelectorAll('.lmg-heart[data-handle]');
    hearts.forEach(function (h) {
      var handle = h.getAttribute('data-handle');
      if (api.has(handle)) {
        h.setAttribute('data-active', 'true');
        h.setAttribute('aria-label', 'Quitar de favoritos');
      } else {
        h.removeAttribute('data-active');
        h.setAttribute('aria-label', 'Guardar en favoritos');
      }
    });
  }

  // Auto-sync count badges: cualquier [data-lmg-wishlist-count]
  function syncCount() {
    var n = api.count();
    document.querySelectorAll('[data-lmg-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-visible', n > 0 ? 'true' : 'false');
    });
  }

  function syncAll() { syncHearts(); syncCount(); }

  // Hook clicks on hearts
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('.lmg-heart[data-handle]');
    if (!heart) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = heart.getAttribute('data-handle');
    var nowActive = api.toggle(handle);
    heart.toggleAttribute('data-active', nowActive);
    // Animation pulse
    heart.classList.remove('lmg-heart--pulse');
    void heart.offsetWidth; // restart
    heart.classList.add('lmg-heart--pulse');
  });

  // Refresh on storage change (cross-tab sync)
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncAll();
  });

  // Subscribe internal sync
  api.subscribe(syncAll);

  // Initial sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  // Sync after partial-renders (Shopify section reload via API)
  document.addEventListener('shopify:section:load', syncAll);
})();
